export default "__VITE_ASSET__CAptm45z__"